import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { SiteIds } from 'src/app/shared/models/site.model'

@Component({
  selector: 'flo-simple-header',
  templateUrl: './simple-header.component.html',
  styleUrls: ['./simple-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleHeaderComponent {
  @Input()
  public siteId: SiteIds
  @Input()
  public isLoginDisplayed = false
  @Input()
  public isSignupDisplayed = false
  @Output()
  public signUpButtonClicked = new EventEmitter<void>()
  @Output()
  public loginButtonClicked = new EventEmitter<void>()
  public get isButtonsDisplayed(): boolean {
    return this.isLoginDisplayed || this.isSignupDisplayed
  }

  handleClickLogin() {
    this.loginButtonClicked.emit()
  }

  handleClickSignup() {
    this.signUpButtonClicked.emit()
  }
}
